<template>
  <div id="serve">
    <div class="service">
      <div class="header">
        <img class="header-img" src="@/assets/img/service/banner.png">
        <div class="title">
          <div>服务介绍</div>
          <img src="https://spkg.smartmice.cn/resources/images/official/common/downBtn.png">
        </div>
      </div>
      <div class="double-row double-row-first">
        <div id="platform" style="position: absolute; top: -80px"></div>
        <div class="container">
          <div class="row-title">
            <div class="letter">P</div>
            <div class="txt">
              <div class="name">平台服务</div>
              <div class="subname">latform services</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineLeft.png">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_img">
              <img src="https://spkg.smartmice.cn/resources/images/official/service/2.png">
            </div>
            <div class="details_txt">
              会引擎 ： 以会议管理+服务为核心，通过与客户深度合作及内部系统对接，提供全面，严谨，极致的商务场景服务及增值；
              <br />
              <span class="details_txt_span">-&emsp;全品类资源整合及管理；</span>
              <span class="details_txt_span">-&emsp;智慧化流程管理及合规监管；</span>
              <span class="details_txt_span">-&emsp;会议服务执行管理及智能辅助工具；</span>
              <span class="details_txt_span details_txt_span_last">-&emsp;深度数据统计及分析系统；</span>
              <br />
              活动兔：以会议营销+服务为核心，通过轻便，灵活的方式，并附以智能工具，为用户提供快捷，节省，超值的服务，及更多的增值；
              <br />
              <span class="details_txt_span">-&emsp;多品类资源整合及管理；</span>
              <span class="details_txt_span">-&emsp;顾问一站式快捷服务；</span>
              <span class="details_txt_span">-&emsp;策划及媒体营销增值工具；</span>
              <span class="details_txt_span">-&emsp;费用及商机统计；</span>
              <router-link to="/platform-services">
                <span>查看案例</span>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/arrowRight2.png">
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="single-row">
        <div id="network" style="position: absolute; top: -80px"></div>
        <div class="container">
          <div class="row-title">
            <div class="letter">T</div>
            <div class="txt">
              <div class="name">人才网络</div>
              <div class="subname">alent Network</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineRight.jpg">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_txt">
              通过人才共享模式，完成人员选拔、培训，撮合，监管等工作，支持平台服务落地执行，提供多元化专业人才服务
              <br>
              <span class="details_txt_span">-&emsp;与国家合作制定专业服务课程；</span>
              <span class="details_txt_span">-&emsp;线上线下培训教育及考核体系；</span>
              <span class="details_txt_span">-&emsp;在线业务撮合平台；</span>
              <span class="details_txt_span">-&emsp;标准化执行服务工具；</span>
              <span class="details_txt_span">-&emsp;覆盖全国的各级会议服务人才网络；</span>
              <router-link to="/training-service">
                <span>查看案例</span>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/arrowRight2.png">
              </router-link>
            </div>
            <div class="details_img">
              <img src="https://spkg.smartmice.cn/resources/images/official/service/3.png">
            </div>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div id="meeting" style="position: absolute; top: -80px"></div>
        <div class="container">
          <div class="row-title">
            <div class="letter">I</div>
            <div class="txt">
              <div class="name">智能会议</div>
              <div class="subname">ntelligent meeting</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineLeft.png">
          </div>
          <div class="clear"/>
          <div class="content">
            <div class="details_img">
              <img src="https://spkg.smartmice.cn/resources/images/official/service/4.png">
            </div>
            <div class="details_txt">
              <span style="float: right">通过人工智能等成熟技术，根据客户需求及服务具体场景，提供智慧化硬件解决方案，提升会议效率及用户体验；
                <br>-&emsp;基于物联网、人工智能等技术的会议软件；
                <br>-&emsp;适用于具体服务场景的智能硬件；
                <br>-&emsp;标准预置的智能会议场地；
                <br>-&emsp;基于客户需求的智能会议解决方案；
              </span>
              <router-link to="/meeting">
                <span>查看案例</span>
                <img src="https://spkg.smartmice.cn/resources/images/official/common/arrowRight2.png">
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
export default {
  name: "Service",
  components: {
    Footer
  }
};
</script>
<style lang="less" scoped>
@import '../../less/service.less';
.single-row {
  background: #ffffff;
  position: relative;
  .row-title {
    float: right;
  }
}
.double-row {
  background: #f6f6f6;
  position: relative;
  .row-title {
    float: left;
  }
}
.double-row-first {
  margin-top: 65px;
}
</style>
